import { registerComponent } from '@gig/magic-common';
import SignUpConsentsComponent from './sign-up-consents.vue.js';

var SignUpConsents = registerComponent(SignUpConsentsComponent);

export { SignUpConsents };
